import { ShipmentDetails } from "models/shipmentDetails/ShipmentDetails";
import React from "react";
import { Link } from "@material-ui/core";
import { theme } from "styling/theme";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { RiskChip } from "components/RiskChip/RiskChip";
import { productTypeWidgetFormatting } from "helpers/productTypeStringFormatting";
import { ColumnDefinition } from "components/LynxTable/ColumnDefinition";

export const laneViewShipmentsTableColumns: ColumnDefinition<ShipmentDetails>[] =
    [
        {
            id: "shipmentId",
            headerTitle: "Shipment ID",
            render: ({ swpShipmentId, routeId }: ShipmentDetails) => {
                const { url } = useRouteMatch();

                return (
                    <Link
                        component={RouterLink}
                        to={`${url}/routes/${routeId}/shipments/${swpShipmentId}`}
                        style={{ color: theme.colors.primary.blue500 }}
                    >
                        {swpShipmentId}
                    </Link>
                );
            },
        },
        {
            // transportationMode
            id: "transportationMode",
            headerTitle: "mode(s) of transportation",
        },
        {
            id: "riskLevel",
            headerTitle: "risk level",
            render: ({ riskLevel }: ShipmentDetails) => (
                <RiskChip
                    riskLevel={
                        riskLevel.toLowerCase() as
                            | "low"
                            | "high"
                            | "medium"
                            | "healthy"
                    }
                />
            ),
            sortable: true,
            align: "left",
        },
        {
            id: "reason",
            headerTitle: "reason",
            sortable: true,
        },
        {
            id: "alertsCount",
            headerTitle: "number of alerts",
            render: (rowData: ShipmentDetails) => "None",
            align: "left",
        },
        {
            id: "productType",
            headerTitle: "product type",
            render: ({ productType }: ShipmentDetails) =>
                productTypeWidgetFormatting(productType),
            align: "left",
            sortable: true,
        },
        {
            id: "routeId",
            headerTitle: "parent route",
            render: ({ routeId, routeName }: ShipmentDetails) => {
                const { url } = useRouteMatch();

                return (
                    <Link
                        component={RouterLink}
                        to={`${url}/routes/${routeId}`}
                        style={{ color: theme.colors.primary.blue500 }}
                    >
                        {routeName}
                    </Link>
                );
            },
            align: "left",
            // sortable: true,
        },
    ];
